import { apiFetch } from './client';

export interface LabelRow {
  id: string;
  name: string;
  color: string | null;
}

export const labelsApi = {
  list(params?: { search?: string; customerId?: string }): Promise<{ rows: LabelRow[] }> {
    const q = new URLSearchParams();
    if (params?.search) q.set('search', params.search);
    if (params?.customerId) q.set('customer_id', params.customerId);
    const qs = q.toString();
    return apiFetch(`/api/labels${qs ? `?${qs}` : ''}`);
  },
};
